export const environment = {
  production: false,
  baseUrl: window.location.origin,
  translateDir: '',
  contemiCPSlogic: true,
  captchaKey: '6Lc-sFYsAAAAAAfTQRv4heSyGj2uyt_DIDoSV7Al',
  azureKlp: {
    clientID: 'a192c659-d607-4e60-b66a-4b6829bde01b',
    loginUrl: 'https://login.microsoftonline.com/9250d77a-d0cc-4ed6-b041-a36ccc3b26ea/'
  },
  azureWatercircles: {
    clientID: 'cc002593-6f86-4aa5-a7b7-37e4237873c6',
    loginUrl: 'https://login.microsoftonline.com/3c1c9130-d9a4-4797-a5da-76756f36b377/'
  }
};
